(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("quill"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["quill", ], factory);
	else if(typeof exports === 'object')
		exports["vue3-editor"] = factory(require("quill"), require("vue"));
	else
		root["vue3-editor"] = factory(root["quill"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__6c81__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 